export class CostReviewElectricalDocumentation {
  asBuiltDrawingsProvided!: number;
  oneLineDrawingsProvided!: number;
  wiringDiagramsProvided!: number;
  equipmentSettingsOrPowerSystemStudiesProvided!: number;
  photographsProvided!: number;
  nameplatesProvided!: number;
  documentationComments!: string;
}
